export default [
  {
    path: '/extrato',
    view: 'Extrato',
    dir: 'views/app/Extrato/',
    title: 'Extrato',
    icon: '',
    menu: true,
    home: true,
    meta: {}
  },
  {
    path: '/lembrar',
    view: 'Lembrar',
    dir: 'views/',
    title: 'Lembrar',
    icon: '',
    meta: {
      anonymousAuth: true,
    }
  },
  {
    path: '/senha/recuperar',
    view: 'Recuperar',
    dir: 'views/',
    title: 'Recuperar',
    icon: '',
    meta: {
      anonymousAuth: true,
    }
  },
  {
    path: '/',
    title: 'Login',
    meta: { anonymousAuth: true },
    props: { loginField: 'documento' },
    component: () => import('@bmp-vue/core/views/Login.vue')
  }    
]
